// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d688786a","455":"8f64188d","977":"697843b5"}[chunkId] + ".chunk.js";
};